import { Theme } from '@emotion/react';

import { rgba } from './color';
import neutralPalette from './neutralPalette';

const theme: Theme = {
  fonts: [],
  typography: {
    heading1: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '5rem',
        leader: '105%',
      },
      mobile: {
        size: '2.5rem',
        leader: '105%',
      },
    },
    heading2: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '4rem',
        leader: '105%',
      },
      mobile: {
        size: '2.25rem',
        leader: '110%',
      },
    },
    heading3: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '3rem',
        leader: '115%',
      },
      mobile: {
        size: '1.875rem',
        leader: '120%',
      },
    },
    ['heading3-large']: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '3rem',
        leader: '115%',
      },
      mobile: {
        size: '2.25rem',
        leader: '120%',
      },
    },
    heading4: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '2.5rem',
        leader: '120%',
      },
      mobile: {
        size: '1.5rem',
        leader: '125%',
      },
    },
    heading5: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '2rem',
        leader: '125%',
      },
      mobile: {
        size: '1.313rem',
        leader: '125%',
      },
    },
    heading6: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '1.5rem',
        leader: '125%',
      },
      mobile: {
        size: '0.875rem',
        leader: '125%',
      },
    },
    ['heading6-large']: {
      family: '"GazpachoHeavy", sans-serif',
      weight: 500,
      desktop: {
        size: '1.5rem',
        leader: '125%',
      },
      mobile: {
        size: '1.25rem',
        leader: '125%',
      },
    },
    subheadline1: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'uppercase',
      desktop: {
        size: '1.25rem',
        leader: '140%',
      },
      mobile: {
        size: '1rem',
        leader: '140%',
      },
      spacing: '0.1em',
    },
    subheadline2: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'uppercase',
      desktop: {
        size: '1rem',
        leader: '140%',
      },
      mobile: {
        size: '0.875rem',
        leader: '140%',
      },
      spacing: '0.1em',
    },
    subheadline3: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'uppercase',
      desktop: {
        size: '0.875rem',
        leader: '140%',
      },
      mobile: {
        size: '0.75rem',
        leader: '140%',
      },
      spacing: '0.1em',
    },
    text1: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      spacing: 'normal',
      desktop: {
        size: '2rem',
        leader: '135%',
      },
      mobile: {
        size: '1.5rem',
        leader: '135%',
      },
    },
    text2: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1.625rem',
        leader: '140%',
      },
      mobile: {
        size: '1.25rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    text3: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1.25rem',
        leader: '150%',
      },
      mobile: {
        size: '1.125rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    ['text3-small']: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1.25rem',
        leader: '150%',
      },
      mobile: {
        size: '1rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    text4: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1.125rem',
        leader: '150%',
      },
      mobile: {
        size: '1rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    text5: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1rem',
        leader: '150%',
      },
      mobile: {
        size: '0.875rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    text6: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '0.875rem',
        leader: '150%',
      },
      mobile: {
        size: '0.813rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    text7: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '0.75rem',
        leader: '150%',
      },
      mobile: {
        size: '0.75rem',
        leader: '140%',
      },
      spacing: 'normal',
    },
    cardTitle: {
      family: '"SofiaProSoft", sans-serif',
      weight: 400,
      boldWeight: 500,
      transform: 'none',
      desktop: {
        size: '1.75rem',
        leader: '135%',
      },
      mobile: {
        size: '1.375rem',
        leader: '135%',
      },
      spacing: 'normal',
    },
  },
  colors: {
    global: {
      black: neutralPalette.black,
      white: neutralPalette.white,
      error: '#ED0303',
      bg10: rgba(neutralPalette.black, 0.1),
      darkBendBlue: '#206872',
      tealDark: '#026572',
      tealMedium: '#089C9C',
      tealLight: '#D3F0F0',
      greenDark: '#018847',
      greenMedium: '#39BC66',
      greenLight: '#D0F3DC',
      softGreenDark: '#549D3A',
      softGreenMedium: '#A0D088',
      softGreenLight: '#DEF5D3',
      green6: '#016C39',
      yellowDark: '#D4A600',
      yellowMedium: '#EED65B',
      yellowLight: '#FCF8D1',
      orangeDark: '#CA6438',
      orangeMedium: '#FFA578',
      orangeLight: '#FFE8D2',
      redDark: '#B43E58',
      redMedium: '#FF7291',
      redLight: '#FFDADA',
      purpleDark: '#6C2D6C',
      purpleMedium: '#B666B6',
      purpleLight: '#E9D4F2',
      blueDark: '#384275',
      blueMedium: '#6471B4',
      blueLight: '#DBDFF1',
      greyDark: '#292927',
      greyMedium: '#62605C',
      greyLight: '#97948D',
      lightGreyDark: '#D3D2CE',
      lightGreyMedium: '#F2F0EE',
      neutralWhite: '#FFFFFF',
      // unique non-design colors
      intakeBackground: '#EDF9F9',
      followupBackground: '#ECFAF1',
      followupColor: '#01703A',
      actionNeededBackground: '#FFF0F0',
      actionNeededColor: '#AA3A0A',
    },
    main: {
      text: {
        primary: neutralPalette.black,
        accent: neutralPalette.white,
      },
      background: {
        primary: neutralPalette.black,
        accent: neutralPalette.white,
      },
    },
    inverted: {
      text: {
        primary: neutralPalette.white,
        accent: neutralPalette.black,
      },
      background: {
        primary: neutralPalette.white,
        accent: neutralPalette.black,
      },
    },
  },
};

export default theme;
